import { AllState } from '../store';

const getEditUserProfileState = (state: AllState) => {
  return state.editUserProfile;
};

export default {
  getEditUserProfileState,
};
